import { render } from "./Curtir.vue?vue&type=template&id=1511eb90"
const script = {}
script.render = render

export default script